import { r as registerInstance, c as createEvent, h, H as Host, g as getElement } from './index-8f7fb048.js';
import { g as getNamespacedTagFor } from './index-739b155e.js';

const marketFileUploadCss = ":host,::slotted(*),*{box-sizing:border-box}:host([disabled]){cursor:not-allowed !important;}:host([disabled]) *,:host([disabled]) ::slotted(*){cursor:not-allowed !important;pointer-events:none !important;}button,.market-button,::slotted(button),::slotted(.market-button),::slotted(.market-link){font-weight:var(--core-type-semibold-30-weight);font-size:var(--core-type-semibold-30-size);font-family:var(--core-type-semibold-30-font-family);line-height:var(--core-type-semibold-30-leading);letter-spacing:var(--core-type-semibold-30-tracking);text-transform:var(--core-type-semibold-30-case)}:host([invalid]) .label-container{border-color:var(--field-normal-state-invalid-validity-border-color)}:host([disabled]) .label-container{border-color:var(--field-disabled-state-border-color);background-color:var(--field-disabled-state-background-color);color:var(--field-disabled-state-empty-phase-label-color)}:host([disabled]) button,:host([disabled]) market-accessory,:host([disabled]) ::slotted(button),:host([disabled]) ::slotted(.market-button),:host([disabled]) ::slotted(.market-link),:host([disabled]) svg{opacity:0.3}.label-container{border:var(--file-upload-border-width, 1px)\n    dashed\n    var(--file-upload-normal-state-border-color, var(--core-fill-30-color));border-style:dashed;border-radius:var(--file-upload-border-radius, 6px)}.label-container>label,.label-container>market-row{padding:var(--file-upload-vertical-padding, 28px)\n      var(--file-upload-button-horizontal-padding, var(--core-metrics-spacing-200))}.label-container>label{display:flex;justify-content:center;align-items:center;cursor:pointer}.label-container>label svg{margin-right:20px;fill:var(--file-upload-label-fill-color, var(--core-fill-10-color))}.label-container>market-row{margin:0}.is-dragging-over{border:var(--file-upload-border-width, 1px)\n    solid\n    var(--file-upload-dragging-state-border-color, var(--core-blue-fill-color));background-color:var(--file-upload-dragging-state-background-color, var(--core-emphasis-40-color))}.has-file-selected{border:var(--file-upload-border-width, 1px)\n    solid\n    var(--file-upload-file-selected-state-border-color, var(--core-fill-30-color))}button,.market-button,::slotted(button),::slotted(.market-button),::slotted(.market-link){padding:var(--file-upload-button-padding, 0);border:none;background-color:inherit;color:var(--file-upload-button-label-color, var(--button-normal-variant-tertiary-rank-normal-state-label-color));font-family:inherit;text-align:right;cursor:pointer}::slotted([slot='helper']){color:var(--file-upload-helper-text-color, var(--core-text-20-color))}.market-accessory{cursor:pointer}.market-accessory svg{fill:var(--file-upload-delete-fill-color, var(--core-fill-20-color))}";

const MarketFileUpload = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.marketFileUploadValueChange = createEvent(this, "marketFileUploadValueChange", 7);
    this.accept = '';
    this.value = [];
    this.disabled = false;
    this.invalid = false;
    this.multiple = false;
    this.deleteButtonAriaLabel = 'Delete';
    this.isDraggingOver = false;
    this.files = undefined;
  }
  watchValueHandler(newValue) {
    this.files = [...newValue];
  }
  /**
   * We want to disable certain functions if multiple is false and a file has been selected
   */
  get hasSingleFileSelected() {
    return !this.multiple && this.files.length === 1;
  }
  draggingOver(e) {
    if (this.disabled || this.hasSingleFileSelected) {
      return;
    }
    this.isDraggingOver = true;
    e.preventDefault();
  }
  endDrag(e) {
    e.preventDefault();
    if (this.disabled || this.hasSingleFileSelected) {
      return;
    }
    this.isDraggingOver = false;
    if (e.type === 'drop' && e.dataTransfer) {
      this.addFiles(e.dataTransfer.files);
    }
  }
  handleButtonClick() {
    this.fileInputElement.click();
  }
  handleDeleteKeydown(e, index) {
    if (e.key === 'Enter' && !this.disabled) {
      this.removeFile(index);
    }
  }
  removeFile(index) {
    this.files.splice(index, 1);
    this.files = [...this.files];
    this.emitFileChange();
  }
  labelContainerClassNames() {
    const classNames = [];
    if (this.isDraggingOver) {
      classNames.push('is-dragging-over');
    }
    if (this.hasSingleFileSelected) {
      classNames.push('has-file-selected');
    }
    return classNames;
  }
  onInputChange(e) {
    this.addFiles(e.target.files);
    // unset the file input value so that we can re-add files
    // if they are removed by the user
    this.fileInputElement.value = '';
  }
  addFiles(files) {
    if (files) {
      if (!this.multiple) {
        this.files = [files[0]];
      }
      else {
        this.files = [...files, ...this.files];
      }
    }
    this.emitFileChange();
  }
  emitFileChange() {
    this.marketFileUploadValueChange.emit({ value: this.files });
  }
  componentWillLoad() {
    this.files = [];
  }
  render() {
    const MarketRowTagName = getNamespacedTagFor('market-row');
    const MarketListTagName = getNamespacedTagFor('market-list');
    const MarketAccessoryTagName = getNamespacedTagFor('market-accessory');
    const MarketFieldTagName = getNamespacedTagFor('market-field');
    const fileMarketRows = this.files.map((file, index) => {
      return (h(MarketRowTagName, { disabled: this.disabled, interactive: true, transient: true, "data-index": index }, h("label", { slot: "label" }, file.name), h(MarketAccessoryTagName, { slot: "trailing-accessory", size: "icon", tabindex: this.disabled ? -1 : 0, role: "button", "aria-label": this.deleteButtonAriaLabel, onKeyDown: (e) => this.handleDeleteKeydown(e, index), onClick: () => this.removeFile(index) }, h("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { d: "M21 5H19H17H15C15 3.35 13.65 2 12 2C10.35 2 9 3.35 9 5H7H5H3V7H5V18.75C5 20.54 6.66 22 8.7 22H15.3C17.34 22 19 20.54 19 18.75V7H21V5ZM12 4C12.55 4 13 4.45 13 5H11C11 4.45 11.45 4 12 4ZM17 18.75C17 19.43 16.22 20 15.3 20H8.7C7.78 20 7 19.43 7 18.75V7H17V18.75ZM15 9H13V18H15V9ZM9 9H11V18H9V9Z" })))));
    });
    const showUploadLabel = this.multiple || fileMarketRows.length === 0;
    const showList = this.multiple && fileMarketRows.length > 0;
    return (h(Host, { class: "market-file-upload", ondragenter: (e) => this.draggingOver(e), ondragover: (e) => this.draggingOver(e), ondragleave: (e) => this.endDrag(e), ondrop: (e) => this.endDrag(e) }, h(MarketFieldTagName, { disabled: this.disabled, invalid: this.invalid }, h("div", { class: `label-container ${this.labelContainerClassNames()}` }, !showUploadLabel && fileMarketRows[0], showUploadLabel && (h("label", null, h("svg", { width: "14", height: "20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { d: "M8 0H3C1.34 0 0 1.34 0 3v14c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3V6L8 0Zm3.17 6H8V2.83L11.17 6ZM12 17c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1h3v6h6v9Z" })), h("span", null, h("slot", null, "Drag and drop here or ", h("button", { onClick: () => this.handleButtonClick() }, "browse file"))), h("input", { ref: (el) => (this.fileInputElement = el), onChange: (e) => this.onInputChange(e), type: "file", name: "files[]", multiple: this.multiple, accept: this.accept, hidden: true })))), h("slot", { name: "helper" }, h("small", { slot: "helper" })), h("slot", { name: "error" }, h("small", { slot: "error" }))), showList && (h(MarketListTagName, { interactive: true, transient: true }, fileMarketRows))));
  }
  get el() { return getElement(this); }
  static get watchers() { return {
    "value": ["watchValueHandler"]
  }; }
};
MarketFileUpload.style = marketFileUploadCss;

export { MarketFileUpload as market_file_upload };
